
import { defineComponent, ref, onMounted, nextTick } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { rutEsValido, formatRut, yupIsRut } from "@/core/validators/YupRut";

interface ProfileDetails {
  id: number;
  contactoRut: string;
  contactoNombre: string;
  contactoEmail: string;
  contactoTelefono: string;
}

export default defineComponent({
  name: "add-ticket-modal",
  components: {
    Field,
    Form,
    ErrorMessage,
  },

  setup() {
    const store = useStore();
    const router = useRouter();

    const submitButton = ref<HTMLButtonElement | null>(null);

    const ticket = Yup.object().shape({
      contactoNombre: Yup.string().required("Es requerido").label("Nombre"),
      contactoEmail: Yup.string()
        .min(4)
        .required("Es requerido")
        .email("No es válido")
        .label("Email"),
      contactoTelefono: Yup.string().required("Es requerido").label("Teléfono"),
      tipo: Yup.string().required("Es requerido").label("Tipo"),
      comentario: Yup.string().required("Es requerido").label("Comentario"),
    });

    const profileDetails = ref<ProfileDetails>({
      id: store.getters.currentProveedor.id,
      contactoNombre: `${store.getters.currentProveedor.contactoNombre} ${store.getters.currentProveedor.contactoApellido}`,
      contactoRut: store.getters.currentProveedor.contactoRut,
      contactoEmail: store.getters.currentProveedor.contactoEmail,
      contactoTelefono: store.getters.currentProveedor.contactoTelefono,
    });
    onMounted(() => {
      store
        .dispatch(Actions.GET_PROVEEDOR)
        .then(() => {
          profileDetails.value = {
            id: store.getters.currentProveedor.id,
            contactoRut: store.getters.currentProveedor.rutProveedor,
            contactoNombre: `${store.getters.currentProveedor.contactoNombre} ${store.getters.currentProveedor.contactoApellido}`,
            contactoEmail: store.getters.currentProveedor.contactoEmail,
            contactoTelefono: store.getters.currentProveedor.contactoTelefono,
          };
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getProveedorErrors);
        });
    });
    const onSubmitTicket = (values) => {
      // eslint-disable-next-line
      submitButton.value!.disabled = true;

      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");
      values.rutProveedor = store.getters.currentProveedor.rutProveedor;
      // Dummy delay
      setTimeout(() => {
        // Send login request
        store
          .dispatch(Actions.INS_TICKET, values)
          .then(() => {
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value!.disabled = false;
            Swal.fire({
              text: "Su solicitud ha sido enviada correctamente",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              router.push({ name: "apps-my-tickets-listing" });
            });
          })
          .catch(() => {
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value!.disabled = false;
            const [error] = Object.keys(store.getters.getTicketErrors);
            Swal.fire({
              text: store.getters.getTicketErrors[error],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Intentar nuevamente!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });
      }, 1);
    };

    return {
      ticket,
      onSubmitTicket,
      profileDetails,
      submitButton,
    };
  },
});
